export const DEFAULT_STORAGE_LIMIT = 524_288_000;
